/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import { NewsItem, NewsState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<NewsState, RootState> = {
  newsList(state): Array<NewsItem> {
    return state.newsList.data;
  },
  news(state): NewsItem {
    return state.news.data;
  },
};
